export default __webpack_public_path__ + "static/media/who-we-are.1f25ed6e.jpg";